import axios from 'axios';
import {BACKEND_URL} from '../constants/ServiceUrl'

export default {
    addToVfe(data) {
        return axios.post(BACKEND_URL+'File/addToVfe.php',data,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
    },
    delete(data) {
        return axios.post(BACKEND_URL+'File/delete.php',data);
    },
    getVfeFiles(id){
        return axios.get(BACKEND_URL+'File/get.php?vfeId='+id);
    },
    getByVcard(vardId) {
        return axios.get(BACKEND_URL+'File/getAllByVcard.php?vcardId='+vardId);
    },
    compress(data) {
        var filewindow = window.open(BACKEND_URL+'File/bulk-download.php?vcardId='+data.vcardId+'&reportingYear='+data.reportingYear);
        const mbSize = parseFloat(data.downloadSize.split(' ')[0], 10)
        var time = 1000
        if (mbSize <= 50) {
            time = 5000
        } else if (mbSize > 50 && mbSize <= 100) {
            time = 7500
        } else if (mbSize > 100) {
            time = 15000
        }
        setTimeout(()=>{
            filewindow.close();
        }, time)
    }
}


// WEBPACK FOOTER //
// ./src/api/FilesApi.js